import { projectsFilters } from 'settings/constants/roles';
import { LISTED_STATUS, transactionStatuses } from 'settings/constants/transactionStatus';

export const PROJECT_TABS = {
  AtRisk: 'At Risk',
  InProgress: 'In Progress',
  Upcoming: 'Upcoming',

  Closed: 'Closed',
  Cancelled: 'Cancelled',
  Expired: 'Expired',
  Archive: 'Archive',
};

function atRisk(filteredTransactions) {
  return filteredTransactions.filter((item) => item.status === transactionStatuses.AtRisk);
}

function inProgressProjects(filteredTransactions) {
  return filteredTransactions.filter((item) => item.status === transactionStatuses.InProgress);
}

function upcomingProjects(filteredTransactions) {
  return filteredTransactions.filter((item) => item.status === transactionStatuses.Upcoming);
}

function onHoldProjects(filteredTransactions) {
  return filteredTransactions.filter((item) => item.status === transactionStatuses.OnHold);
}

function closedTransactionsTableData(filteredTransactions) {
  return filteredTransactions.filter((item) => item.status === transactionStatuses.Closed);
}

function cancelledTransactionsTableData(filteredTransactions) {
  return filteredTransactions.filter((item) => item.status === transactionStatuses.Canceled);
}

function expiredTransactionsTableData(filteredTransactions) {
  return filteredTransactions.filter((item) => item.status === LISTED_STATUS.Expired);
}

function applyProjectsFilter(transactions, projectFilter) {
  switch (projectFilter) {
    case projectsFilters.allProjects:
      return transactions;
    case projectsFilters.myProjects:
      return transactions.filter((item) => item.IsMyTransaction);
    default:
      return transactions;
  }
}

export const prepareProjectData = (dataProps) => {
  const { transactions, projectFilter } = dataProps;

  const filteredTransaction = applyProjectsFilter(transactions, projectFilter);
  return {
    atRisk: atRisk(filteredTransaction),
    inProgress: inProgressProjects(filteredTransaction),
    upcoming: upcomingProjects(filteredTransaction),
    archivedProjects: {
      closed: closedTransactionsTableData(filteredTransaction),
      cancelled: cancelledTransactionsTableData(filteredTransaction),
      expired: expiredTransactionsTableData(filteredTransaction),
    },
  };
};
